import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { HttpService } from '../../services/http.service'
import { SharedService } from '../../services/shared.service'
import { Product } from '../../models/product'
import { MessageDialogComponent } from '../../dialogs/message-dialog/message-dialog.component'
import { SpinnerDialogComponent } from '../../dialogs/spinner-dialog/spinner-dialog.component'

@Component({
  selector: 'app-complete',
  templateUrl: './complete.component.html',
  styleUrls: ['./complete.component.css']
})
export class CompleteComponent {
  product: Product
  modelCode: string
  serialNumber: string
  total: number
  spinner: MatDialogRef<SpinnerDialogComponent>

  constructor(
    private router: Router,
    private http: HttpService,
    private shared: SharedService,
    private dialog: MatDialog,
  ) {
    this.shared.blockRefresh()
    this.product = this.shared.product
    this.modelCode = this.shared.modelCode
    this.serialNumber = this.shared.serialNumber
    this.total = this.shared.total
  }

  onMain(): void {
    this.router.navigateByUrl('/start')
  }

  onCheckOrderStatus(): void {
    this.spinner = this.dialog.open(SpinnerDialogComponent, {
			panelClass: 'transparent',
			disableClose: true
		})
    this.http.getProductsWithPolicyNumber(this.shared.contract.contractNo, this.shared.user.email)
      .subscribe((response) => {
        this.spinner.close()
        console.log(response)
        this.shared.contract = response.data.contractStatusInfoResponse
        this.router.navigateByUrl('/user-info')
      }, (error) => {
				this.spinner.close()
				this.dialog.open(
					MessageDialogComponent, {
					data: {
						title: '',
						description: error.message,
						button: 'Close'
					}
				})
			})
  }
}
